<template>
  <div>
    <c-table-search
      ref="tableSearch"
      :queryParams="queryParams"
      @doSearch="loadData"
    >
      <template v-slot:btns>
        <el-form-item>
          <el-button
            type="primary"
            @click="openModel('costModel')"
          >添加</el-button>
        </el-form-item>
      </template>
    </c-table-search>

     <div class="block">
    <c-table
      @handlePageChange="handlePageChange"
      :dataSource="dataSource"
      :pagination="pagination"
    >
      <template>
        <el-table-column
          prop="title"
          label="招考标题"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          prop="startTime"
          label="报名时间"
          show-overflow-tooltip
        >
          <template slot-scope="{row}">
            {{row.startTime | DateFilter}} 至 {{row.endTime | DateFilter}}
          </template>
        </el-table-column>

        <el-table-column
          label="报名链接"
          show-overflow-tooltip
        >
          <template slot-scope="{row}">
            <a
              :href="getUrl(row.id)"
              target="_blank"
              class="underline"
            >{{getUrl(row.id)}}</a>
          </template>
        </el-table-column>

        <el-table-column
          label="报名二维码"
          show-overflow-tooltip
        >
          <template slot-scope="{row}">
            <a
              :href="getQrcode(row.qrcode)"
              target="_blank"
              class="underline"
            >{{getQrcode(row.qrcode)}}</a>
          </template>
        </el-table-column>

        <el-table-column
          prop="isRelease"
          label="发布状态"
        >
          <template slot-scope="{row}">
            <span>{{row.isRelease===1?'已发布':'未发布'}}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="code"
          label="操作"
          width="340px"
        >
          <template slot-scope="{row}">
            <div
              class="actions"
              v-if="row.isRelease===0"
            >
              <a @click="editInfo(row)">编辑</a>
             
              <el-divider direction="vertical"></el-divider>
              <a @click="editTemplate(row)">报名表维护</a>
              <el-divider direction="vertical"></el-divider>
              <a @click="getPostLists(row)">岗位维护</a>
              <el-divider direction="vertical"></el-divider>
              <a @click="releaseRecruit(row,true)">发布</a>
              <el-divider direction="vertical"></el-divider>
              <a @click="deleteRecruit(row)">删除</a>
            </div>

            <div
              class="actions"
              v-else
            >
              <a @click="editInfo(row)">编辑</a>
             
              <el-divider direction="vertical"></el-divider>
              <a @click="editTemplate(row)">报名表维护</a>
              <el-divider direction="vertical"></el-divider>
              <a @click="getPostLists(row)">岗位维护</a>
              <el-divider direction="vertical"></el-divider>
              <a @click="releaseRecruit(row,false)">取消发布</a>
              <el-divider direction="vertical"></el-divider>
              <a @click="deleteRecruit(row)">删除</a>
            </div>

          </template>
        </el-table-column>
      </template>

    </c-table>
     </div>
    <c-model
      ref="costModel"
      title="招考信息"
      width="60%"
      @confirm="saveInfo()"
      @cancel="clearInfo()"
    >
      <el-form
        ref="form"
        :model="info"
        label-width="130px"
      >
        <el-form-item
          label="招考标题:"
          prop="title"
          required
        >
          <el-input v-model="info.title"></el-input>
        </el-form-item>

        <!-- <el-form-item
          label="公司简介:"
          prop="companyIntro"
        >

          <vue-ueditor-wrap
            v-model="info.companyIntro"
            :config="ueConfig"
          ></vue-ueditor-wrap>
        </el-form-item> -->

        <el-form-item
          label="招聘简章:"
          prop="detail"
          required
        >
          <vue-ueditor-wrap
            v-model="info.detail"
            :config="ueConfig"
          ></vue-ueditor-wrap>
        </el-form-item>

        <el-form-item
          label="准考证注意事项:"
          prop="note"
          required
        >
          <vue-ueditor-wrap
            v-model="info.note"
            :config="ueConfig"
          ></vue-ueditor-wrap>
        </el-form-item>

        <el-form-item
          label="报名起始日期:"
          prop="startTime"
          required
        >
          <el-date-picker
            v-model="info.startTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>

        </el-form-item>

        <el-form-item
          label="报名截止日期:"
          prop="endTime"
          required
        >
          <el-date-picker
            v-model="info.endTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>

        </el-form-item>

        <el-form-item
          label="招考环节:"
          prop="steps"
          required
        >

          <a
            class="editLink"
            @click="openModel('linkModel')"
          >点击编辑</a>
          <span>
            {{getStepsInfo}}
          </span>

        </el-form-item>

        <el-form-item
          label="公司logo:"
          prop="companyLogo"
          required
        >
          <c-upload
            :extraData="{type:10}"
            accept="image/*"
            @uploadSuccess="uploadSetFields('companyLogo',$event)"
            :fileUrl="info.companyLogo"
          >
            <el-button
              size="small"
              type="primary"
            >点击上传(建议200*40)</el-button>
          </c-upload>

        </el-form-item>

        <el-form-item
          label="岗位表:"
          prop="post"
        >
          <c-upload
            :extraData="{type:5}"
            @uploadSuccess="uploadSetFields('post',$event)"
            :fileUrl="info.post"
          >
            <el-button
              size="small"
              type="primary"
            >点击上传</el-button>
          </c-upload>

        </el-form-item>

        <el-form-item
          label="诚信承诺书:"
          prop="pledge"
        >
          <c-upload
            :extraData="{type:3}"
            @uploadSuccess="uploadSetFields('pledge',$event)"
            :fileUrl="info.pledge"
          >
            <el-button
              size="small"
              type="primary"
            >点击上传</el-button>

          </c-upload>

        </el-form-item>

        <el-form-item
          label="专业目录:"
          prop="major"
        >
          <c-upload
            :extraData="{type:4}"
            @uploadSuccess="uploadSetFields('major',$event)"
            :fileUrl="info.major"
          >
            <el-button
              size="small"
              type="primary"
            >点击上传</el-button>

          </c-upload>

        </el-form-item>

        <el-form-item
          label="报名表标题:"
          prop="enrollTitle"
        >
          <el-input v-model="info.enrollTitle"></el-input>
        </el-form-item>

      </el-form>
    </c-model>
    <c-link-model
      ref="linkModel"
      :data="this.info.steps"
      @saveLink="saveLink"
    ></c-link-model>
    <c-model
      ref="signUpModel"
      width="60%"
      title="报名表维护"
      @confirm="closeModel('signUpModel')"
    >
      <el-button
        type="primary"
        class="addFields"
        @click="openModel('addFieldModel')"
      >增加字段</el-button>
      <c-register-form
        disabled
        :extraFields="extraFields"
        @removeFileds="removeFileds"
      ></c-register-form>
    </c-model>

    <c-model
      ref="addFieldModel"
      title="字段编辑"
      @confirm="confirmAddField"
    >
      <el-form
        ref="addFieldForm"
        :model="extraField"
        label-width="100px"
      >
        <el-form-item
          label="字段名称:"
          prop="fieldName"
          required
        >
          <el-input
            v-model="extraField.fieldName"
            placeholder="请输入字段名称(不能重复)"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="字段编码:"
          prop="fieldCode"
          required
          :rules="{type:'fieldcode'}"
        >
          <el-input
            v-model="extraField.fieldCode"
            placeholder="字段名以字母开头,不能含有特殊字符(不能重复,例如code1)"
          ></el-input>
        </el-form-item>
      </el-form>

    </c-model>

    <c-post-model
      ref="postModel"
      :data="this.postList"
      @savePost="savePost"
    ></c-post-model>

  </div>

</template>

<script>
import config from '@/config/ApiConfig'
import { recruitRes } from '@/api'
import TableMixin from '@/mixins/TableMixin'
import UeditorMixin from '@/mixins/UeditorMixin'
import { mapGetters } from 'vuex'
import CLinkModel from './components/C-Link-Model'
import CPostModel from './components/C-Post-Model'
export default {
  mixins: [TableMixin, UeditorMixin],
  components: { CLinkModel, CPostModel },
  data: function() {
    return {
      queryParams: [
        {
          label: '招考标题',
          code: 'title'
        },
        {
          label: '发布状态',
          code: 'isRelease',
          type: 'select',
          options: [
            {
              name: '全部',
              value: ''
            },
            {
              name: '已发布',
              value: 1
            },
            {
              name: '未发布',
              value: 0
            }
          ]
        }
      ],
      info: {
        title: '',
        companyIntro: '',
        companyLogo: '',
        detail: '',
        note: '',
        startTime: '',
        endTime: '',
        steps: [],
        //岗位表链接
        post: '',
        //诚信承诺书
        pledge: '',
        //专业目录
        major: '',
        //报名表标题
        enroll_title:''
      },
      extraFields: [],
      extraField: {
        fieldName: '',
        fieldCode: ''
      },
      activeRow: {},
      postList: []
    }
  },
  created() {},
  computed: {
    ...mapGetters(['getRecruitList']),
    getStepsInfo() {
      var info = ''
      this.info.steps &&
        this.info.steps.forEach((step, index) => {
          if (index === this.info.steps.length - 1) {
            info = info + step.name + ''
          } else {
            info = info + step.name + '/'
          }
        })
      return info
    }
  },
  methods: {
    preview(id){
      // const url = this.getUrl(id)
      this.$router.push('/recruitDetail/'+id)
    },
    list(params) {
      var data = { ...params, pageSize: this.PAGE_SIZE }
      recruitRes.getPage(data).then(res => {
        var { total, records } = res
        this.pagination.total = total
        this.dataSource = records
      })
    },
    editInfo(row) {
      recruitRes.getDetail({ id: row.id }).then(res => {
        this.info = res
        this.openModel('costModel')
      })
    },
    saveInfo() {
      this.$refs.form.validate(valid => {
        console.log(valid)
        if (valid) {
          recruitRes.save(this.info).then(res => {
            this.$message.success('保存成功')
            this.closeModel('costModel')
            this.info = {}
            this.$refs.tableSearch.doSearch()
          })
        }
      })
    },
    clearInfo() {
      this.info = {}
    },

    uploadSetFields(fieldName, uploadRes) {
      this.info[fieldName] = uploadRes.filePath
    },
    getUrl(id) {
      var locationHref = window.location.host
      return 'http://' + locationHref + '#/recruitDetail/' + id
    },
    getQrcode(relativeQrcode) {
      return config.apiServer + '/' + relativeQrcode
    },
    saveLink(linkData) {
      this.info.steps = linkData
      this.closeModel('linkModel')
    },
    //发布招考信息
    releaseRecruit(row, isRelease) {
      recruitRes.release({ id: row.id, isRelease }).then(res => {
        this.$refs.tableSearch.doSearch()
        this.$message.success('操作成功')
      })
    },
    //删除招考信息
    deleteRecruit(row) {
      this.$confirm('确认删除该招考信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        recruitRes.deleteRecruit({ id: row.id }).then(res => {
          this.$refs.tableSearch.doSearch()
          this.$message.success('删除成功')
        })
      })
    },
    getPostLists(row) {
      this.activeRow = row
      recruitRes.getPostList({ examId: row.id }).then(res => {
        this.postList = res
        this.openModel('postModel')
      })
    },
    savePost(posts) {
      var { id } = this.activeRow
      recruitRes.savePost({ examId: id, posts }).then(res => {
        this.$message.success('保存成功')
        this.postList = []
        this.closeModel('postModel')
      })
    },
    //编辑报名表
    editTemplate(row) {
      this.activeRow = row
      recruitRes.getTemplateFields({ examId: row.id }).then(res => {
        this.openModel('signUpModel')
        this.extraFields = res
      })
    },
    //添加报名表字段
    confirmAddField() {
      this.$refs.addFieldForm.validate((valid, errInfo) => {
        if (valid) {
          var data = {
            examId: this.activeRow.id,
            ...this.extraField
          }
          //调用后台逐个保存
          recruitRes.addExtraFields(data).then(res => {
            console.log(res)
            this.extraFields.push(res)
            this.closeModel('addFieldModel')
            this.extraField = {}
          })
        }
      })
    },
    //删除报名表字段
    removeFileds({ id, index }) {
      //调用后台接口，判断字段是否可以被删除(实际不做删除，保存表单时才删除)
      recruitRes.deleteExtraFields({ id }).then(res => {
        this.extraFields.splice(index, 1)
      })
    }
  }
}
</script>
<style lang="scss" >
.editLink {
  text-decoration: underline;
  color: $main-color;
}
.addFields {
  margin-bottom: 30px;
}
.extraFields {
  background-color: #f5f7fa;
}
</style>


